export default __webpack_public_path__ + "645e4946611c4f97945122f30405118f.png";